import { setCurrentChatroom, expandWidget } from './index';
import wix from '../services/wix';
import { AVATARS } from '../constants/avatars';
import socialServerApi from '../services/socialServerApi';
import { WIX_CODE_CHATROOM_TYPE } from '@wix/wix-chat-transform-bo-events/dist/lib/constants-wixCode';
import { lazyLoaders } from '../services/loading-scheduler';
import { ChatRoom } from '@wix/chat-sdk';

const transformChatroomToDisplayData = (room: ChatRoom) => {
  const { id, name, otherParticipantId: userId } = room;
  const imgUrl = room.thumbnail;
  const avatar = imgUrl ? { ...AVATARS.IMG.prop, imgUrl } : AVATARS.NONE.prop;
  return { id, name, userId, avatar };
};

export const startChannel = ({
  type,
  userId,
  requestId,
}: {
  type: string;
  userId: string;
  requestId: string;
}) => {
  return async function (dispatch, getState) {
    const responseEventName = `ChatWidget.startChannelResponse.${requestId}`;
    try {
      const state = getState();
      let chatroomToSet;

      if (type === WIX_CODE_CHATROOM_TYPE.BUSINESS) {
        const { businessChatRoomId = '' } = state;
        if (!businessChatRoomId) {
          return wix.publishToPubSub(responseEventName, { success: false });
        }

        const lazySdk = await lazyLoaders.interactivity.chatSdk();
        chatroomToSet = await lazySdk.chatSdk.getChatroom({
          chatroomId: businessChatRoomId,
        });
      }

      if (type === WIX_CODE_CHATROOM_TYPE.SOCIAL) {
        if (!userId) {
          return wix.publishToPubSub(responseEventName, { success: false });
        }

        const chatrooms = await new Promise<any[]>(async (resolve) => {
          const lazySdk = await lazyLoaders.interactivity.chatSdk();
          return lazySdk.chatSdk.subscribeToChatRoomsList({
            callback: ({ rooms }) => rooms && resolve(rooms),
          });
        });

        const userChatrooms = chatrooms.filter(
          (room) => room.otherParticipantId === userId,
        );

        if (userChatrooms.length < 1) {
          const {
            chatroomId,
            chatroom,
          } = await socialServerApi.createPrivateChatRoom(userId);
          chatroomToSet = chatroom;
          chatroomToSet.id = chatroomId;
        } else {
          chatroomToSet = userChatrooms[0];
        }
      }

      const displayData = transformChatroomToDisplayData(chatroomToSet);
      dispatch(setCurrentChatroom(displayData));
      dispatch(expandWidget());
      return wix.publishToPubSub(responseEventName, {
        success: true,
        results: {
          channelId: displayData.id,
        },
      });
    } catch (e) {
      wix.publishToPubSub(responseEventName, { success: false });
    }
  };
};
